import { useTranslation } from 'react-i18next';
import type { InvoiceTransactionAml } from '../model/types';
import { AML_BADGE_VARIANT_CLASSES, getTransactionAmlBadgeState } from '../lib/aml';
import { cn } from '@shared/lib/utils';

interface TransactionAmlBadgeProps {
  aml?: InvoiceTransactionAml | null;
  onClick?: () => void;
  className?: string;
}

export function TransactionAmlBadge({ aml, onClick, className }: TransactionAmlBadgeProps) {
  const { t } = useTranslation('cabinet');
  const state = getTransactionAmlBadgeState(aml);

  if (!state) return null;

  const labelKey =
    state === 'pending'
      ? 'payments.aml.badgePending'
      : state === 'ok'
        ? 'payments.aml.badgeOk'
        : 'payments.aml.badgeRisk';

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap cursor-pointer',
        AML_BADGE_VARIANT_CLASSES[state],
        className
      )}
    >
      {t(labelKey)}
    </button>
  );
}
